// extracted by mini-css-extract-plugin
module.exports = {"btnSecondary":"CustomButton_btnSecondary__NHC0_","btnPrimary":"CustomButton_btnPrimary__1et97","btnInactive":"CustomButton_btnInactive__fImbX"};